

import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import image13 from  "../../Images/sweepydo_image13.jpg";

import axios from 'axios'
import ToastNotification from "../../components/ToastNotification/ToastNotification";

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "",type:'Enquiry' });

   const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
      setToast({ show: true, message: msg, bg });
    };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };



//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   try {
//     // const res = await axios.post(
//     //   "https://api.sweepydo.in/contact-us",
//     //   formData
//     // );

 
//     showToast("Message sent successfully!",'success');

//     setFormData({ name: "", email: "", message: "" });

//   } catch (error) {
//     console.log(error);
//     showToast("Failed to send message",'danger')
//   }
// };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      await axios.post("https://api.sweepydo.in/contact-us", {
        name: formData.name,
        email: formData.email,
        message: formData.message,
        type: "Enquiry"
      });
      showToast("Message sent successfully", 'success');
      setFormData({
        name: "",
        email: "",
        message: ""
      });
    } catch (error) {
      console.log(error);
      showToast("Failed to send request", 'danger');
    }
  };


  return (
    <>

      
      <section
//   className="d-flex flex-column flex-md-row align-items-center justify-content-between"
//   style={{
//     minHeight: "180px",
//     height: "clamp(180px, 25vh, 260px)",
//     color: "#121313",
//     padding: "20px clamp(20px, 5vw, 60px)",
//     backgroundImage:
//       "url('https://blog.urbancare.co.nz/wp-content/uploads/House-Cleaning-scaled.jpg')",
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//     backgroundRepeat: "no-repeat",
//     position: "relative",
//     overflow: "hidden",
//     fontFamily: "'Montserrat', sans-serif",
//   }}
// >
className="d-flex flex-column flex-md-row align-items-center justify-content-between"
style={{
  minHeight: "260px",
  // height: "220px",
  
  color: "#121313",
  padding: "20px clamp(20px, 5vw, 60px)",
  backgroundImage: `url(${image13})`,
  backgroundSize: "cover",
  backgroundPosition: "center top",
  backgroundRepeat: "no-repeat",
  backgroundColor: "#f5f5f5",
  position: "relative",
  overflow: "hidden",
  fontFamily: "'Montserrat', sans-serif",
  height: "450px",
}}
>

     <ToastNotification
        show={toast.show}
        message={toast.message}
        bg={toast.bg}
        onClose={() => setToast({ ...toast, show: false })}
      />


 
  <div
    style={{
      position: "absolute",
      inset: 0,
   backgroundColor: "rgba(255, 255, 255, 0.45)",
      zIndex: 0,
    }}
  ></div>


  <div
    style={{
      position: "relative",
      zIndex: 1,
      flex: 1,
      textAlign: "center",
      marginBottom: "10px",
    }}
  >
    <h1
      className="fw-bold"
      style={{
        fontSize: "clamp(34px, 4vw, 58px)",
        margin: 0,
        fontWeight: "700",
      }}
    >
      Contact Us
    </h1>
  </div>


  <div
    style={{
      position: "relative",
      zIndex: 1,
      flex: 1,
      textAlign: "center",
    }}
  >
    <div
      style={{
        fontSize: "clamp(14px, 1.2vw, 16px)",
        color: "#555",
        fontWeight: "500",
      }}
    >
      <span
        style={{
          cursor: "pointer",
          color: "#6A20Af",
        }}
        onClick={() => (window.location.href = "/")}
      >
        Home
      </span>{" "}
      &gt; <span>Contact Us</span>
    </div>
  </div>
</section>
     
      <section style={{ padding: "50px 15px", backgroundColor: "#f9f9f9" }}>
        <Container>
          <Row className="mb-5 text-center">
            <Col>
              <h2 style={{ fontWeight: "700", color: "#000", marginBottom: "10px", fontSize: "clamp(24px, 3vw, 36px)" }}>
                Get In Touch
              </h2>
              <p style={{ color: "#555", fontSize: "clamp(14px, 2vw, 16px)" }}>
                Have questions? Reach out to us and we’ll get back to you soon!
              </p>
            </Col>
          </Row>

          <Row className="g-4">
      
            <Col md={4} sm={12}>
              <div className="d-flex flex-column gap-3">
                <div className="d-flex align-items-center gap-2">
                  <FaMapMarkerAlt color="#6A20Af" /> <span>  64, purani chaupal, Dhaka, Mukharjee nagar,  New delhi 110009</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <FaPhone color="#6A20Af" /> <span>9559511604</span>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <FaEnvelope color="#6A20Af" /> <span>Sweepydo@gmail.com</span>
                </div>
              </div>
            </Col>

       
            <Col md={8} sm={12}>
              <Form onSubmit={handleSubmit}>
                <Row className="mb-3">
                  <Col md={6} sm={12} className="mb-2 mb-md-0">
                    <Form.Control
                      type="text"
                      placeholder="Your Name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        padding: "12px",
                        width: "100%",
                        boxSizing: "border-box",
                        transition: "all 0.3s",
                      }}
                      onFocus={(e) => (e.target.style.border = "2px solid #6A20Af")}
                      onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
                    />
                  </Col>
                  <Col md={6} sm={12}>
                    <Form.Control
                      type="email"
                      placeholder="Your Email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      style={{
                        borderRadius: "8px",
                        border: "1px solid #ccc",
                        padding: "12px",
                        width: "100%",
                        boxSizing: "border-box",
                        transition: "all 0.3s",
                      }}
                      onFocus={(e) => (e.target.style.border = "2px solid #6A20Af")}
                      onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
                    />
                  </Col>
                </Row>
                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={5}
                    placeholder="Your Message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      padding: "12px",
                      width: "100%",
                      boxSizing: "border-box",
                      transition: "all 0.3s",
                    }}
                    onFocus={(e) => (e.target.style.border = "2px solid #6A20Af")}
                    onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
                  />
                </Form.Group>
                <Button
                  type="submit"
                  style={{
                    backgroundColor: "#6A20Af",
                    color: "#fff",
                    border: "none",
                    padding: "12px 35px",
                    fontWeight: "600",
                    borderRadius: "8px",
                    transition: "0.3s",
                    width: "100%",
                    maxWidth: "250px",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#c55DF8";
                    e.target.style.color = "#000";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#6A20Af";
                    e.target.style.color = "#fff";
                  }}
                >
                  Send Message
                </Button>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Contact;